// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"Ribbon_Ribbon__QOfEu","RibbonHot":"Ribbon_RibbonHot__1Se_I","RibbonSale":"Ribbon_RibbonSale__cvNfE"};